<template lang="pug">
  .appointment-item
    v-card.px-3.pb-3(style="border-radius:0px")
      v-row(align="center")
        v-col
          p.mb-0.font-weight-bold.subtitle-1.pr-0 {{ appointmentItem.name }}
        v-col(cols="4" align="end")
          v-btn.mr-1(icon @click="showAddAppointmentDialog = true" v-if="member.role === 'Admin'")
            v-icon(color="primary") mdi-square-edit-outline
          v-btn(icon @click="clickDelete" v-if="member.role === 'Admin'")
            v-icon(color="#6E6E6E") mdi-delete-outline
      v-layout
        p.mb-0.body-2 {{ $t('open_appt') }}: {{ appointmentItem.booking_open }} - {{ appointmentItem.booking_close > 1 ? appointmentItem.booking_close + ' days' : appointmentItem.booking_close + ' day' }} {{ $t('before') }}
        v-spacer
        p.mb-0.body-2 {{ appointmentItem.price | displayPrice }}

    .modals
      add-appointment(v-if="showAddAppointmentDialog" :appointment.sync="appointmentItem" :open.sync="showAddAppointmentDialog" :company="company")
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.title {{ $t('delete_product') }}
          v-card-text
            | {{ $t('delete_product_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='grey' text @click='openDeleteDialog = false')
              | {{ $t('cancel') }}
            v-btn(color='red' text @click='startDelete')
              | {{ $t('delete') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AddAppointment from '@/components/dialogs/AddAppointment.vue'

export default {
  name: 'AppointmentItem',
  props: ['appointment', 'company'],
  components: { AddAppointment },
  data: () => ({
    appointmentItem: {},
    showAddAppointmentDialog: false,
    openDeleteDialog: false
  }),
  computed: {
    ...mapState('user', ['member']),
  },
  watch: {
    ...mapActions([
      'showMessage'
    ])
  },
  mounted () {
    this.appointmentItem = this.appointment
  },
  methods: {
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.axios.delete(`/appointment/appointments/${this.appointmentItem.id}/`)
        .then(() => {
          this.$emit('deleted', this.appointmentItem)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "open_appt": "Open appt",
    "before": "before"
  },
  "id": {
    "open_appt": "Buka appt",
    "before": "sebelum"
  }
}
</i18n>
